/**
 * Created by abdulhafeth on 6/28/16.
 */
(function (angular, TeamScheduleAPI) {

    angular
        .module('harriApp')
        .controller('TSEditShiftController', ["$scope", "$filter", "ScheduleDataServiceV2", "ScheduleWarningServiceV2", "SaveShiftForm", "modalData", "onSave", "onDelete", "onStart", "onError", "onPublish", "onRestore", "TeamScheduleService", "userPermissions", "hEvent",
            function ($scope, $filter, ScheduleDataServiceV2, ScheduleWarningServiceV2, SaveShiftForm, modalData, onSave, onDelete, onStart, onError, onPublish, onRestore, TeamScheduleService, userPermissions, hEvent) {

            $scope._saveShiftForm = new SaveShiftForm($scope, ScheduleDataServiceV2, ScheduleWarningServiceV2);
            $scope.mode = modalData.mode;

            if (onStart) {
                onStart();
            }

            $scope.shiftDate = modalData?.day || modalData?.shift?.day || ScheduleDataServiceV2.getShiftDay(modalData.shift);
            $scope.isLocked = modalData.isLocked;
            var defaultEventData;
            var trackedUserId;

            TeamScheduleService.getActiveBrand()
                .then(function (brand) {
                    ScheduleDataServiceV2.setRevenueCenters(brand.revenue_centers);
                    $scope.revenueCenters = ScheduleDataServiceV2.revenueCenters;

                    userPermissions.getBrandPolicy(brand.id)
                        .then(function (policyParser) {
                            $scope.canApproveAndPublishSchedule = policyParser.has(userPermissions.PERMISSIONS.PUBLISH_SCHEDULE);
                            $scope.canManageSchedule = policyParser.has(userPermissions.PERMISSIONS.MANAGE_SCHEDULE);
                            $scope.hasManageHourlyWagesAccess = policyParser.hasAny([userPermissions.PERMISSIONS.MANAGE_HOURLY_EMPLOYEES_WAGES, userPermissions.PERMISSIONS.VIEW_HOURLY_EMPLOYEES_WAGES]);
                            $scope.canPublish = $scope.canApproveAndPublishSchedule && !$scope.isLocked;

                            defaultEventData = {
                                'brand_id': modalData.brand_id,
                                'schedule_id': modalData.schedule_id,
                                'user_with_approval': $scope.canApproveAndPublishSchedule,
                                'tag': 'schedule_creation',
                            };
                            trackedUserId = modalData.shift && modalData.shift.user_id;
                            loadShiftForm();
                        })
                        .catch(function (err) {
                            console.error(err);
                        });
                });

            var loadShiftForm = function () {
                var eventData = _.extend({
                    'shift_id': (modalData.mode == 'EDIT' && modalData.shift.id) || null,
                    'shift_status': trackedUserId ? 'ASSIGNED' : 'UNASSIGNED',
                    'user_id': trackedUserId || null,
                    'event_status': 'SUCCESS',
                }, defaultEventData);
                hEvent.track(modalData.mode == 'EDIT' ? 'schedule_edit_shift_modal_open' : 'schedule_create_shift_modal_open', eventData);
                $scope._saveShiftForm.load({
                    pendingApproval: modalData.pendingApproval,
                    isLocked: $scope.isLocked,
                    canPublish: $scope.canPublish,
                    canApproveAndPublish: $scope.canApproveAndPublishSchedule,
                    canManageSchedule: $scope.canManageSchedule,
                    activeScheduleView: modalData.activeScheduleView,
                    schedule_id: modalData.schedule_id,
                    day: modalData.day || moment(modalData.shift.start_time).format("MMM DD, YYYY"),
                    shift: modalData.shift,
                    revenueCenters: ScheduleDataServiceV2.revenueCenters,
                    hasManageHourlyWagesAccess: $scope.hasManageHourlyWagesAccess,
                    employeeId: modalData.user_id,
                    assigneeId: modalData.shift.assignee_id,
                    slotGroupId: modalData.assigneeId,
                    GFEAppliedCity: modalData.GFEAppliedCity,
                    position_code: modalData.position_code,
                    role_id: modalData.role_id,
                    brand_id: modalData.brand_id,
                    action: modalData.action,
                    mode: modalData.mode,
                    category: modalData.category,
                    userMinorTypes: modalData.userMinorTypes,
                    userChanged: onSelectedUserChanged,
                });
            };

            var onSelectedUserChanged = function (userId) {
                trackedUserId = userId;
            };

            //Create new shift call
            var createNewShiftCall = function(shiftToSend, publish) {
                var eventData = _.extend({
                    'shift_status': trackedUserId ? 'ASSIGNED' : 'UNASSIGNED',
                    'user_id': trackedUserId,
                    'shift_action': 'ADD',
                }, defaultEventData);
                TeamScheduleV2API.createNewShift(modalData.brand_id, modalData.schedule_id || shiftToSend.schedule_id , shiftToSend)
                    .then(function (shift) {
                        var eventName = 'schedule_create_shift_modal_save';
                        if (publish) {
                            eventName += '_publish';
                        }
                        let shiftAssignee = null;
                        for (const role of shift.roles) {
                            for (const roleDay of role.role_days) {
                                const assignee = roleDay.assignees.find(assignee => assignee.user_id === trackedUserId);
                                if (assignee?.assignee_shifts.length) {
                                    shiftAssignee = assignee;
                                    break;
                                }
                            }
                            if (shiftAssignee) {
                                break;
                            }
                        }
                        eventData.shift_id = shiftAssignee?.assignee_shifts?.[0].id;
                        eventData.event_status = 'SUCCESS';
                        hEvent.track(eventName, eventData);
                        onSave(shift, modalData.action, publish);
                        $scope.hide();
                    }, function (err) {
                        var eventName = 'schedule_create_shift_modal_save';
                        if (publish) {
                            eventName += '_publish';
                        }
                        eventData.event_status = 'FAIL';
                        hEvent.track(eventName, eventData);
                        onError && onError(err, "create");
                        console.error(err);
                        $scope.hide();
                    });
            };

            $scope._saveShiftForm.onPublish(function () {
                onPublish(modalData.shift, modalData.action);
                $scope.hide();
            });


            $scope._saveShiftForm.onRestoreConsent(function (shift) {
                onSave(shift, modalData.action);
                $scope.hide();
            });

            $scope._saveShiftForm.onRestore(function () {
                onRestore(modalData.shift, modalData.action);
                $scope.hide();
            });

            $scope._saveShiftForm.onSaved(function (shift, publish) {
                var newShift = angular.copy(shift);
                newShift.user_id = newShift.user_id || null;
                newShift.status = "UNPUBLISHED";

                var shiftToSend = {
                    position_code: newShift.position_code,
                    end_time: newShift.end_time,
                    user_id: newShift.user_id,
                    schedule_id: newShift.schedule_id,
                    start_time: newShift.start_time,
                    labels: [],
                    note: newShift.note,
                    weight: newShift.weight,
                    job_titles: newShift.job_titles,
                    is_requested_by_assignee: newShift.is_requested_by_assignee
                };

                if (newShift.incentive_payments) {
                    shiftToSend["incentive_payments"] = newShift.incentive_payments;
                }

                if (newShift.forecasted_recurrence) {
                    shiftToSend['forecasted_recurrence'] = newShift.forecasted_recurrence;
                }

                if (ScheduleDataServiceV2.shiftsTemplates && ScheduleDataServiceV2.shiftsTemplates[newShift.code] && ScheduleDataServiceV2.shiftsTemplates[newShift.code].id) {
                    shiftToSend["template_id"] = ScheduleDataServiceV2.shiftsTemplates[newShift.code].id;
                }
                else {
                    shiftToSend["color"] = null;
                }

                if (newShift.breaks) {
                    shiftToSend["breaks"] = newShift.breaks;
                }

                var newRole = ScheduleDataServiceV2.getRoleFromPosition(newShift.position_code);

                if (newRole) {
                    var shiftDay = ScheduleDataServiceV2.getShiftDay(newShift);
                    var roleDayId = ScheduleDataServiceV2.mappings['day_role'][shiftDay + '_' + newRole.id];
                    var assigneeId = roleDayId && ScheduleDataServiceV2.mappings['user_roleday'][newShift.user_id + '_' + roleDayId];

                    if (assigneeId) {
                        shiftToSend['role_id'] = newRole.id;
                        shiftToSend['assignee_id'] = assigneeId;
                        delete shiftToSend['user_id'];
                        delete shiftToSend['position_code'];
                    }
                    else if (shiftToSend['user_id']) {
                        shiftToSend['role_id'] = newRole.id;
                        delete shiftToSend['position_code'];
                    }

                }

                if (shift.revenue_center_id) {
                    shiftToSend['revenue_center_id'] = shift.revenue_center_id;
                }

                if (shift.labels) {
                    shiftToSend.labels = shift.labels.map((label) => label.id);
                }

                if (!shift.shift_id) {

                    if(!shiftToSend.schedule_id) {
                        modalData.getScheduleId(true)
                            .then(function (scheduleId){
                                shiftToSend.schedule_id = scheduleId;
                                createNewShiftCall(shiftToSend, publish);
                            });
                    } else {
                        createNewShiftCall(shiftToSend, publish);
                    }
                } else {

                    var eventData = _.extend({
                        'shift_id': shift.shift_id,
                        'shift_status': trackedUserId ? 'ASSIGNED' : 'UNASSIGNED',
                        'user_id': trackedUserId,
                        'shift_action': 'EDIT',
                    }, defaultEventData);
                    TeamScheduleV2API.editShift(modalData.brand_id, modalData.schedule_id, shift.shift_id, shiftToSend)
                        .then(function (shift) {
                            var eventName = 'schedule_edit_shift_modal_save';
                            if (publish) {
                                eventName += '_publish';
                            }
                            eventData.event_status = 'SUCCESS';
                            hEvent.track(eventName, eventData);

                            onSave(shift, modalData.action, publish);
                            $scope.hide();
                        }, function (err) {
                            var eventName = 'schedule_edit_shift_modal_save';
                            if (publish) {
                                eventName += '_publish';
                            }
                            eventData.event_status = 'FAIL';
                            hEvent.track(eventName, eventData);
                            if (err && err.data && err.data.status === 'SCHEDULE_LOCKED') {
                                onError && onError(err, "edit");
                                $scope.hide();
                            }
                            else if (err.status === 400) {
                                $scope._saveShiftForm.onError(err.data.status);
                            }
                            console.error(err);
                        });
                }


            });

            $scope.hide = function () {
                $('body').removeClass('is-manage-shift-modal-open');

                $scope.$hide();
                try {
                    $scope.$digest();
                } catch (e) {
                }
            };

            $scope._saveShiftForm.onSaveShiftCanceled(function () {
                $scope.hide();
            });

                $scope._saveShiftForm.onDelete(function (shift, isRequestedByAssignee) {
                var params = {'is_requested_by_assignee': isRequestedByAssignee};

                var eventData = _.extend({
                    'shift_id': modalData.shift.id,
                    'user_id': trackedUserId,
                    'shift_status': trackedUserId ? 'ASSIGNED' : 'UNASSIGNED',
                    'shift_action': 'DELETE',
                }, defaultEventData);
                TeamScheduleAPI.deleteScheduleShift(ScheduleDataServiceV2.scheduleId, modalData.shift.assignee_id, modalData.shift.id, params)
                    .then(function (res) {
                            eventData.event_status = 'SUCCESS';
                            hEvent.track('schedule_edit_shift_modal_delete_shift', eventData);
                            setTimeout(function() {
                                onDelete(shift, res);
                            }, 1);

                            $scope.hide();
                        },
                        function (err) {
                            eventData.event_status = 'FAIL';
                            hEvent.track('schedule_edit_shift_modal_delete_shift', eventData);
                            console.error(err);
                            onError && onError(err, "delete");
                            $scope.hide();
                        });
            });
        }]);

})
(angular,  TeamScheduleAPI);
